// extracted by mini-css-extract-plugin
module.exports = {"list":"links-block-module--list--19Mdk","listItem":"links-block-module--list-item--2-xJ0","listItemLink":"links-block-module--list-item-link--14NJx"};